<div class="select-box-container">
  <dx-select-box
    [dataSource]="subcategoryDataSource"
    [(value)]="selectedSubcategory"
    displayExpr="displayValue"
    label="Subcategory"
    stylingMode="underlined"
  ></dx-select-box>

  <dx-select-box
    [(value)]="selectedInputName"
    [dataSource]="inputNameDataSource"
    [disabled]="inputNameItemDisabled"
    displayExpr="displayValue"
    label="Input Name"
    stylingMode="underlined"
  ></dx-select-box>

  <!-- default ui input types -->
  <dx-check-box
    *ngIf="uiInputType === 'full'"
    [(value)]="selectedIsDefault"
    [disabled]="!inputNameChoosen"
    text="Is Default"
  ></dx-check-box>

  <dx-number-box
    *ngIf="uiInputType === 'full'"
    [(value)]="selectedSortOrder"
    [disabled]="!inputNameChoosen"
    label="Sort Order"
    stylingMode="underlined"
  ></dx-number-box>

  <dx-text-box
    *ngIf="uiInputType === 'full'"
    [(value)]="selectedDefaultValue"
    [disabled]="!inputNameChoosen || requiredQuantityType !== 'OPTION_VALUE'"
    label="Default Option Value"
    stylingMode="underlined"
  ></dx-text-box>

  <!-- cartons ui input types -->
  <dx-text-box
    *ngIf="uiInputType === 'cartons'"
    [(value)]="selectedDefaultCartonValue"
    [disabled]="!inputNameChoosen"
    label="Default Carton Value"
    stylingMode="underlined"
  ></dx-text-box>

</div>
